<div [formGroup]="parentForm">
  <div class="da-card">
    <h3 class="card-title">Experience <span class="title-badge-required" style="color: #666;" *ngIf="parentForm.get('hasExperience')?.value">CV upload is mandatory</span></h3>

    <div class="field-group mb-16">
      <label>Do you have any work experience? <span class="required">*</span></label>
        <p-selectButton [options]="yesNoOptions" formControlName="hasExperience" optionLabel="label" optionValue="value"
          [class.ng-invalid]="isFieldInvalid(parentForm, 'hasExperience')"
          [class.ng-dirty]="isFieldInvalid(parentForm, 'hasExperience')"></p-selectButton>
        <app-field-error [control]="parentForm.get('hasExperience')" type="requiredOnly" fieldName="This selection"></app-field-error>
      </div>


    <ng-container *ngIf="parentForm.get('hasExperience')?.value">

      <div formArrayName="experience">
        <div *ngFor="let exp of experience.controls; let i=index" [formGroupName]="i" class="exp-item">
          <div class="card-header-actions">
            <div class="title">Experience {{i+1}}</div>
            <div class="actions">
              <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-text" style="color: #ef4444; background: transparent; border: none; font-size: 1.2rem; cursor: pointer;" (click)="removeExperience(i)"></button>
            </div>
          </div>

          <div class="file-upload-row mt-16" [class.has-file]="exp.get('fileUrl')?.value">
            <ng-container *ngIf="exp.get('fileUrl')?.value; else noExpFile">
              <div class="uploaded-file-pill">
                <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
                <div class="file-details">
                  <div class="file-name-row">
                    <span class="file-name" (click)="previewFile(exp.get('fileUrl')?.value, 'Experience ' + (i+1) + ' CV')" title="CV">
                      Experience_{{i+1}}_CV.pdf
                    </span>
                    <i class="pi pi-check-circle check-icon" style="color: #16a34a;"></i>
                  </div>
                  <div class="file-meta">Uploaded &middot; autofilled below</div>
                </div>
                <input type="file" #expReplaceInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, expReplaceInput)">
                <button type="button" class="replace-btn" title="Replace" (click)="expReplaceInput.click()">Replace</button>
              </div>
            </ng-container>
            <ng-template #noExpFile>
              <div class="uploaded-file-pill" style="opacity: 0.6;">
                <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
                <div class="file-details">
                  <div class="file-name-row">
                    <span class="file-name" style="color: #9ca3af;">Experience {{i+1}} CV — Not uploaded</span>
                  </div>
                  <div class="file-meta" style="color: #f97316;"><i class="pi pi-upload" style="font-size: 11px;"></i> No file yet</div>
                </div>
                <input type="file" #expUploadInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, expUploadInput)">
                <button class="replace-btn" (click)="expUploadInput.click()">Upload</button>
              </div>
            </ng-template>
          </div>
          <app-field-error [control]="exp.get('fileUrl')" type="requiredOnly" fieldName="CV/Document" style="margin-bottom: 16px; display: block;"></app-field-error>

          <div class="form-grid single-col">
            <!-- Organisation: full width -->
            <div class="field-group">
              <label>Organisation Name <span class="required">*</span></label>
              <input pInputText formControlName="organisation" placeholder="e.g. Infosys Ltd."
                [class.ng-invalid]="isFieldInvalid(exp, 'organisation')"
                [class.ng-dirty]="isFieldInvalid(exp, 'organisation')" />
              <app-field-error [control]="exp.get('organisation')" type="alphanumericText" fieldName="Organisation Name"></app-field-error>
            </div>

            <!-- Designation -->
            <div class="field-group">
              <label>Designation / Job Title <span class="required">*</span></label>
              <input pInputText formControlName="designation" placeholder="e.g. Software Developer"
                [class.ng-invalid]="isFieldInvalid(exp, 'designation')"
                [class.ng-dirty]="isFieldInvalid(exp, 'designation')" />
              <app-field-error [control]="exp.get('designation')" type="alphanumericText" fieldName="Designation"></app-field-error>
            </div>

            <!-- Location: City (text) + Country (dropdown) -->
            <div class="field-group">
              <label>Location (City, Country)<span class="required">*</span></label>
              <div class="location-split-row">
                <div style="flex: 1;">
                  <input pInputText formControlName="city" placeholder="City" class="city-input"
                    [class.ng-invalid]="isFieldInvalid(exp, 'city')"
                    [class.ng-dirty]="isFieldInvalid(exp, 'city')" />
                  <app-field-error [control]="exp.get('city')" type="cityName" fieldName="City"></app-field-error>
                </div>
                <div style="flex: 1;">
                  <p-dropdown
                    formControlName="country"
                    [options]="countryOptions"
                    placeholder="Country"
                    [filter]="true"
                    filterPlaceholder="Search country..."
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [class.ng-invalid]="isFieldInvalid(exp, 'country')"
                    [class.ng-dirty]="isFieldInvalid(exp, 'country')">
                  </p-dropdown>
                  <app-field-error [control]="exp.get('country')" type="requiredOnly" fieldName="Country"></app-field-error>
                </div>
              </div>
            </div>

            <!-- Duration: two inputs side by side within full-width row -->
            <div class="field-group">
              <label>Duration (From – To) <span class="required">*</span></label>
              <div class="duration-row" style="display: flex; align-items: center; gap: 8px;">
                <p-calendar formControlName="durationFrom" dateFormat="dd/mm/yy" placeholder="e.g. 01/06/2023" [readonlyInput]="true" appendTo="body"
                  [class.ng-invalid]="isFieldInvalid(exp, 'durationFrom')" [class.ng-dirty]="isFieldInvalid(exp, 'durationFrom')"></p-calendar>
                <span class="duration-sep">–</span>
                <p-calendar formControlName="durationTo" dateFormat="dd/mm/yy" placeholder="e.g. 01/08/2023" [readonlyInput]="true" appendTo="body"
                  [class.ng-invalid]="isFieldInvalid(exp, 'durationTo')" [class.ng-dirty]="isFieldInvalid(exp, 'durationTo')"></p-calendar>
              </div>
              <div class="error-msg" *ngIf="isFieldInvalid(exp, 'durationFrom') || isFieldInvalid(exp, 'durationTo')">
                <span>Duration is required</span>
              </div>
            </div>

            <!-- Key Responsibilities: full width -->
            <div class="field-group" >
              <label>Key Responsibilities <span class="required">*</span></label>
              <textarea pInputTextarea formControlName="responsibilities" rows="3" class="p-inputtextarea"
                placeholder="e.g. Built full-stack features for an HR analytics platform..."
                [class.ng-invalid]="isFieldInvalid(exp, 'responsibilities')"
                [class.ng-dirty]="isFieldInvalid(exp, 'responsibilities')"></textarea>
              <app-field-error [control]="exp.get('responsibilities')" type="description500" fieldName="Responsibilities"></app-field-error>
            </div>
          </div>

          <!-- Save / Update Button Container -->
          <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1rem;">
            <button pButton type="button" 
                    [label]="exp.get('id')?.value ? 'Update' : 'Save'"
                    icon="pi pi-check"
                    class="p-button-sm p-button-primary"
                    [loading]="isSavingMap[i]"
                    [disabled]="isSavingMap[i]"
                    style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
                    (click)="saveExperience(i)">
            </button>
          </div>
          <div class="unsaved-warning" *ngIf="exp.dirty">
            You have unsaved changes. Please click {{ exp.get('id')?.value ? 'Update' : 'Save' }} to continue.
          </div>

        </div>
      </div>

      <div class="add-item-trigger" (click)="addExperience()">
        <button class="btn-link">+ Add Another Experience</button>
      </div>
    </ng-container>

    <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1rem;" *ngIf="parentForm.get('hasExperience')?.value === false">
      <button pButton type="button" 
              [label]="hasNoExperienceRecordId ? 'Update' : 'Save'"
              icon="pi pi-check"
              class="p-button-sm p-button-primary"
              [loading]="isSavingNoExperience"
              [disabled]="isSavingNoExperience"
              style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
              (click)="saveNoExperience()">
      </button>
    </div>
    <div class="unsaved-warning" *ngIf="parentForm.get('hasExperience')?.value === false && parentForm.get('hasExperience')?.dirty">
      You have unsaved changes. Please click {{ hasNoExperienceRecordId ? 'Update' : 'Save' }} to continue.
    </div>

  </div>
  
  <p-toast></p-toast>

  <!-- Custom Delete Confirmation Dialog -->
  <p-dialog
    [(visible)]="showDeleteDialog"
    [modal]="true"
    [closable]="!isDeleting"
    [dismissableMask]="!isDeleting"
    [style]="{width: '450px'}"
    styleClass="custom-delete-dialog"
    header="Delete Confirmation">
    <div style="display:flex; align-items:center; gap:16px; justify-content:center; padding: 0.5rem 0;">
      <span style="background:#eef2ff; border-radius:50%; width:60px; height:60px; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0;">
        <i class="pi pi-exclamation-triangle" style="font-size:28px; color:#0b0a66;"></i>
      </span>
      <span style="font-size:17px; font-weight:600; color:#000; line-height:1.5;">Are you sure you want to delete this experience entry?</span>
    </div>
    <ng-template pTemplate="footer">
      <button pButton
        class="custom-confirm-no"
        label="No"
        icon="pi pi-times"
        (click)="cancelDelete()"
        [disabled]="isDeleting">
      </button>
      <button pButton
        class="custom-confirm-yes"
        [label]="isDeleting ? 'Deleting...' : 'Yes'"
        [icon]="isDeleting ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        (click)="confirmDelete()"
        [disabled]="isDeleting">
      </button>
    </ng-template>
  </p-dialog>
<!-- </div> -->

  <!-- Shared PDF Preview Dialog -->
  <p-dialog [(visible)]="displayPreviewDialog" [modal]="true" [header]="previewFileName" [dismissableMask]="true"
      [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
      <div class="text-center p-4 relative preview-dialog-body">
          <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" width="100%" height="600px" style="border: none;"></iframe>
      </div>
  </p-dialog>
</div>
